import React, { Component } from 'react'
import Layout from '../../components/Layout';
import PageHead from '../../components/pageHead';
import { Container, Row, Col, Accordion, Card } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import Mfooter from '../../components/mobile-footer-tag';
import cookie from 'next-cookies';
import SelectCity from '../../components/select-city';
import { _getFilterArray, _proceedValue, _checkCookies } from '../../utils';

export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accordionData: [
                {
                    "id": 1,
                    "head": 'Can GadgetZippy repair my Apple device if it’s still under warranty?',
                    "content": (<div> Yes, we can repair your Apple device even if it’s under warranty. However, it’s important to remember that if repairs are done outside of Apple’s authorised service centres, you may not get a service from there without spending again. Be sure to contact us for more information.</div>), "isChecked": ((cookie({ "ctx": '' }).isFaq) == undefined) ? false : ((cookie({ "ctx": '' }).isFaq).name == 'Can GadgetZippy repair my Apple device if it’s still under warranty?') ? true : false
                },
                {
                    "id": 2,
                    "head": 'What should I do if my iPhone isn’t charging?',
                    "content": (<div>If your phone isn’t charging properly, there could be three reasons behind it - a damaged cable, a faulty charging port, or software issue. 
                       <br/> Be sure to give our iPhone repair and replacement service in India, if you need help fixing it.
                        </div>),
                    "isChecked": ((cookie({ "ctx": '' }).isFaq) == undefined) ? false : ((cookie({ "ctx": '' }).isFaq).name == 'What are the cities GadgetZippy.com operates in?') ? true : false
                },
                {
                    "id": 3,
                    "head": 'Do you offer diagnostics for free?',
                    "content": (<div> No, if you don’t avail of our other services, we will charge INR 499. However, the pricing might differ considering what kind of services we are offering. Be sure to give us a call to know more about it.
                        </div>),
                    "isChecked": ((cookie({ "ctx": '' }).isFaq) == undefined) ? false : ((cookie({ "ctx": '' }).isFaq).name == 'How do I place a service request at GadgetZippy.com?') ? true : false
                },
                {
                    "id": 4,
                    "head": 'How much does a MacBook screen replacement cost?',
                    "content": (<div>The cost of a MacBook screen replacement might vary considering the model you are using. We provide a transparent price breakdown after a diagnostic test to ensure you know the cost upfront.</div>),
                    "isChecked": ((cookie({ "ctx": '' }).isFaq) == undefined) ? false : ((cookie({ "ctx": '' }).isFaq).name == 'How much does GadgetZippy.com charge for its repair service?') ? true : false
                },
                
            ],
            location: this.props.location == undefined ? 'location' : this.props.location,
            csCheck: this.props.isChecked == undefined ? false : true,
            canonical: this.props.canonical,
            metaData: {
                "metatitle": 'FAQ Gadgetzippy',
                "metaDescription": "Read the most frequently asked questions on Gadgetzippy. Contact +91-9912699999 or send an email to Repair@gadgetzippy.com for unanswered questions.",
                "metaKeywords": 'GadgetZippy, iPhone Repair Shop'
            },
        }
    }
    accordionMenu = (event) => {
        this.state.accordionData.find(res => {
            if (res.id == event.id) {
                if (res.isChecked == true) {
                    res.isChecked = false
                } else {
                    res.isChecked = true
                }
            }
        })
        this.setState({ accordionData: this.state.accordionData })
    }
    static async getInitialProps(ctx) {
        let location = cookie(ctx).location
        var checkCookies = await _checkCookies(ctx, location);
        return { "isChecked": cookie(ctx).isChecked, "location": location, "canonical": "https://www.gadgetzippy.com" + ctx.asPath }
    }
    disabledFooter = () => {
        this.setState({ csCheck: true })
        document.cookie = `isChecked=` + true;
    }

    handleClose = () => {
        this.setState({
            show: false
        })
        this.setState({
            location: cookie({ "ctx": '' }).location
        })
    }

    handleOpen = () => {
        this.setState({
            show: true
        })
    }

    handleClose1 = () => { }

    componentDidMount = () => {
        var acc = document.getElementsByClassName("accordion");
        var i;

        for (i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        }
        if ((cookie({ "ctx": '' }).isFaq) != undefined) {
            this.highlatingAcc(this.state.accordionData)
        }
    }

    highlatingAcc = (accordionData) => {
        var acc = document.getElementsByClassName("accordion");
        var i;
        var j = 0
        accordionData.map(res => {
            if (res.isChecked) {
                j = (res.id - 1)
            }
        })
        for (i = 0; i < acc.length; i++) {
            if (j == i) {
                acc[j].classList.add('active')
                var panel = acc[j].nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            }
        }
    }

    checkedBox = (data) => {
        console.log(data)
        this.state.accordionData.map(res => {
            if (res.head == data.name) {
                res.isChecked = true
            } else {
                res.isChecked = false
            }
        })
        this.setState({ accordionData: this.state.accordionData })
        this.highlatingAcc(this.state.accordionData)
    }

    render() {
        let { show, location, metaData, canonical } = this.state
        return (
            <div>
                <PageHead title="Gadget Zippy | Mobile repairs" meta={metaData} canonical={canonical}></PageHead>
                    <Container fluid={true} className="faq">
                        <div className="thank-you pt-sm-4 pb-sm-4 text-center">Frequently Asked Questions </div>
                        <div className="pb-4">
                            <div className="mb-5 faq-box-bg ml-sm-3 mr-sm-3">
                                {this.state.accordionData.map((res, index) => (
                                    <div className={index == (this.state.accordionData.length - 1) ? "custome-accodion mb-1" : "custome-accodion mb-2 pb-1"} key={index}>
                                        
                                        <button className="accordion">
                                            <h3>{res.head}
                                            <img src={`${publicRuntimeConfig.staticFolder}/images/uparrow-sm.svg`} alt="uparrow-sm" className="float-right mt-sm-2 m-accordion-img1" />
                                            <img src={`${publicRuntimeConfig.staticFolder}/images/down-arrow.svg`} alt="down-arrow" className="float-right mt-sm-2 pt-sm-1 m-accordion-img" />
                                            </h3>
                                        </button>
                                        <div className="panel">
                                            <div className="divider-line mb-3"></div>
                                            <div className={index == (this.state.accordionData.length - 1) ? "name-mobile text-left" : "name-mobile text-left mb-3"}>{res.content}</div>
                                        </div>
                                    </div>))}
                            </div>
                        </div>
                    </Container>
                {this.state.csCheck == false && <Mfooter disabledFooter={this.disabledFooter} />}
                {show && <SelectCity show={show} isClose={false} handleClose={this.handleClose} handleClose1={this.handleClose1} />}
            </div>
        )
    }
}